<template>
    <wrapper :left="left" :center="center" :right="right" class="h-40">
        <a href="https://apps.apple.com/us/app/spoferan/id1546584648" target="_blank" rel="noopener">
            <cdn-image src="logos/badges/apple/download-app-store-black.svg" :size="{width: 120, ratio: 120/40}" alt="Laden im App Store"/>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.spoferan.app" target="_blank" rel="noopener">
            <cdn-image src="logos/badges/google/download-google-play.png" :size="{width: 154, ratio: 646/250}" alt="Laden im Google Play Store"/>
        </a>
    </wrapper>
</template>

<script>
import Alignable from "../../mixins/Alignable";

export default {
name: "AppFeatureButtons",
    mixins: [Alignable]
}
</script>